export interface PubSubNegotiateRes {
  connectionString: string;
}